import Immutable from 'seamless-immutable';
import _ from 'lodash';

import CampaignPromotionModel from './promotion-model';

function deserialize(campaignPromotion) {
  return Immutable(_.map(campaignPromotion, CampaignPromotionModel.deserialize));
}

export default {
  create: deserialize,
  deserialize,
};
